import {BaseView} from "../core/view"
import constants from "./constants"
import FiltersView from "./mobile-filters-view"
import SortByView from "./mobile-sort-by-view"
import CategoriesView from "./mobile-categories-view"
import { MobileUtil } from "../utils/mobile"
import { TrackingUtil } from "../utils/tracking"

export default BaseView.extend({

    el: '.js-mobile-bar',
    windowScrollPosition: 0,
    viewIsVisible: false,
    loadedViews: [],
    filterTopPosition: 0,
    initialized: false,

    events: {
        'click .js-tab-open': 'toggleView',
        'click .js-mobile-bar-view-close': 'closeView',
    },

    initialize: function() {
        if (this.$el.length){
            this.initializeScrollSnap();
            if(this.filterTopPosition > 0) {
                this.initialized = true;
            }

            if (MobileUtil.isAndroid()){
                let self = this;
                $(window).on('orientationchange',function(){
                    self.setTabHeight();
                });
            }
        }
    },

    initializeScrollSnap: function() {
        this.filterTopPosition = $('.js-filter-wrapper').offset().top;
        if ($(window).scrollTop() > this.filterTopPosition){
            this.$el.addClass('tab-groups--fixed');
        } else if(this.$el.hasClass('tab-groups--fixed')) {
            this.$el.removeClass('tab-groups--fixed');
        }

        let self = this;
        $(window).on("scroll.filterbar",function(){
            if ($(this).scrollTop() > self.filterTopPosition) {
                if (!self.$el.hasClass('tab-groups--fixed')) {
                    self.$el.addClass('tab-groups--fixed');
                }
            }else {
                if (self.$el.hasClass('tab-groups--fixed')){
                    self.$el.removeClass('tab-groups--fixed');
                }
            }
        });

        $(window).on("resize",function(){
            this.filterTopPosition = $('.js-filter-wrapper').offset().top;
        });

    },

    deactivateScrollSnap: function() {
        $(window).off("scroll.filterbar");
    },

    setTabHeight: function(){
        const viewportHeight= $(window).height();
        this.$el.find('.js-tab-dropdown').height(viewportHeight-36-this.$el.height());
    },

    closeView: function(){
        this.viewIsVisible = false;
        $('.main-wrapper').removeClass('disable-scrolling');
        const windowScrollTop = $(window).scrollTop();
        $('body').scrollTop(windowScrollTop);
        document.body.removeAttribute('style');
        this.$el.find('.tab--active').removeClass('tab--active');
        $('body').removeClass('filter-bar--is-active');
        this.initializeScrollSnap();
    },

    manageLoadedViews: function(activatedView){
        if(!this.loadedViews.includes(activatedView)) {
            this.loadedViews.push(activatedView);
            let gaAction = '';

            if (activatedView == "categories-tab") {
                gaAction = 'New Category View';
                new CategoriesView();
            }
            if (activatedView == "filters-tab") {
                gaAction = 'New Filter View';
                new FiltersView();
            }
            if (activatedView == "sort-tab") {
                gaAction = 'New Sort View';
                new SortByView();
            }

            TrackingUtil.throwGAEvent(constants.TRACK_MOBILE_SEARCH_BAR, gaAction, '', false);
        }

    },

    toggleView: function(e) {
        e.preventDefault();
        if(!this.initialized) {
            this.initializeScrollSnap();
            this.initialized = true;
        }

        let tab = this.$el.find(e.currentTarget);
        let buttonParent = tab.parent();
        if (buttonParent.hasClass('tab--active')){
            this.closeView();
        }else if (this.viewIsVisible){
            this.$el.find('.tab--active').removeClass('tab--active');
            buttonParent.addClass('tab--active');
            this.manageLoadedViews(tab.data('view'));
        }else{
            this.deactivateScrollSnap();
            if (!this.$el.hasClass('tab-groups--fixed')) {
                this.moveToFixed(e);
            } else {
                this.openView(e);
            }
        }
    },

    openView: function(e) {
        e.preventDefault();

        let tab = this.$el.find(e.currentTarget);
        let buttonParent = tab.parent();
        if(!buttonParent.hasClass('tab--active')) {
            if (MobileUtil.isAndroid()) {
                this.setTabHeight();
            }

            this.windowScrollPosition = $(window).scrollTop();
            this.viewIsVisible = true;

            $('body').height($('.main-wrapper').height());
            $('.main-wrapper').addClass('disable-scrolling');
            $('body').scrollTop(this.windowScrollPosition);
            $('.main-wrapper').scrollTop(this.windowScrollPosition);

            this.$el.find('.tab--active').removeClass('tab--active');
            buttonParent.addClass('tab--active');
            $('body').addClass('filter-bar--is-active');
            this.$el.addClass('tab-groups--fixed');
            const activateView = tab.data('view');
            this.manageLoadedViews(activateView);
        }
    },

    moveToFixed: function(clickedElem){
        const self = this;
        const pos = this.filterTopPosition + 1;
        $('html,body').animate({ scrollTop: pos }, 100, function(){
            self.openView(clickedElem);
        });
    }
});